import React from 'react';
import * as Icons from '@tishman/icons';
import { Text } from '@tishman/components';

interface FormErrorTextProps {
  id: string;
  children: React.ReactNode;
}

export const FormErrorText: React.FC<FormErrorTextProps> = ({
  id,
  children,
}) => {
  return (
    <Text id={id} role="alert" variant="formError">
      <Icons.Warning style={{ marginBottom: '-4px', marginRight: '4px' }} />
      {children}
    </Text>
  );
};
